<script lang="ts">
import ModuleSalarie from '@/generated/modules/ModuleSalarie.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleSalarie
})

</script>
